<script lang="ts">
	import { goto } from '$app/navigation';
	import type { LoginResponse } from '@enzianweb/shared';
	import { addDaysToDate, getLicences, Icon, licenceEndKey, login, renewBus } from '@enzianweb/shared';
	import { onDestroy } from 'svelte';
	import { _ } from 'svelte-i18n';
	import { fade } from 'svelte/transition';

	const dayThreashhold = 30;

	let showLicenceIsGoingToEnd: boolean = $state(false);
	let differenceInDays: number | null = $state(null);

	const unsub = login.subscribe((login) => {
		if (login == null || !login.admin) return;

		checkIfPanelShouldBeDisplayed(login);
	});

	const busUnsub = renewBus.subscribe((val) => {
		if (val != null) {
			showLicenceIsGoingToEnd = false;
		}
	});

	onDestroy(() => {
		unsub();
		busUnsub();
	});

	async function loadLicenceInfos(login: LoginResponse): Promise<string> {
		//Load the last licences
		const licences = await getLicences(login.firmId);

		//Get the latest licence
		const latestLicence = licences[licences.length - 1];

		//Set the new end date
		localStorage.setItem(licenceEndKey, latestLicence.validUntil);

		return latestLicence.validUntil;
	}

	async function checkIfPanelShouldBeDisplayed(login: LoginResponse) {
		try {
			let licenceEndDate = localStorage.getItem(licenceEndKey) as string;

			//In case we don't have any end date yet load the info
			if (
				!licenceEndDate ||
				new Date().getTime() > addDaysToDate(new Date(licenceEndDate), -dayThreashhold).getTime()
			) {
				//Do the licence loading stuff
				licenceEndDate = await loadLicenceInfos(login);
			}

			//We need the difference in days for now
			differenceInDays = Math.round(
				(new Date(licenceEndDate).getTime() - new Date().getTime()) / (1000 * 3600 * 24)
			);

			//If the day diff is smaller than x we display the panel
			if (differenceInDays <= dayThreashhold && differenceInDays >= 1) {
				showLicenceIsGoingToEnd = true;
			}
		} catch (ex) {
			console.error(ex);
		}
	}

	function closeInfo() {
		//Close the modal
		showLicenceIsGoingToEnd = false;
	}
</script>

{#if showLicenceIsGoingToEnd && $login?.admin && differenceInDays && differenceInDays >= 1}
	<div class="bg-white dark:bg-dark-200 rounded flex shadow-lg items-center" transition:fade>
		<div class="icon flex items-center rounded-l bg-primary-100 dark:bg-secondary-500 px-2 py-6">
			<Icon name="exclamation" classInfo="fill-white" />
		</div>

		<div class="px-4 grow">
			<p class="font-bold">
				{$_('licence_ending.lbl_header')}
			</p>

			<p class="">
				{@html $_('licence_ending.lbl_text').replace('{}', differenceInDays.toString())}
				<button
					onclick={(e) => {
						e.preventDefault();
						closeInfo();
						goto('settings?tab=Logins+%26+Lizenzen');
					}}
					class="text-secondary-200 dark:text-secondary-500"
				>
					{$_('licence_ending.link_renewal')}
				</button>
			</p>
		</div>

		<button class="p-4" onclick={closeInfo}>
			<Icon name="xmark" classInfo="dark:fill-white"></Icon>
		</button>
	</div>
{/if}
